<script>
export default {
    name:'CMP_AIS_00005_COMP_BASE',
    components:{},
    props:{
        row:{type:Object, default: () => {},},
        value:{type:[Number, String] },
        text:{type:[Number, String] },
    },
    data(){
        return {
        }
    },
    computed:{
        getClass(){
            let clazz = [];
            if(this.row.statusCode === 'C') {
                clazz.push('disable');
            }
            return clazz;
        },
    },
    methods:{
        getComponent(name) {
            let component = null;
            let thisComponent = this;
            while(thisComponent && !component) {
                if(thisComponent.$options.name === name) {
                    component = thisComponent;
                    break;
                }
                thisComponent = thisComponent.$parent;
            }
            return component;
        },
    },
}
</script>
<style scoped>
</style>